import api from '@shared/api';
import { ExperimentTemplate } from '@experiment-details/types';

type TemplateReqData = {
  project_id: string;
  template_id: string | null;
};

const chartApi = {
  fetchProjectTemplate(projectId: string, experimentKey: string) {
    const url = `chart-templates/project/get?projectId=${projectId}&experimentKey=${experimentKey}`;

    return api.get<ExperimentTemplate>(url);
  },

  fetchUserTemplates(projectId: string, experimentKey: string) {
    const url = `chart-templates/project/get-all?projectId=${projectId}&experimentKey=${experimentKey}`;

    return api.get<{ templates: ExperimentTemplate[] }>(url);
  },

  saveTemplate(data: ExperimentTemplate) {
    const url = `chart-templates/upsert`;
    return api.post<ExperimentTemplate>(url, data);
  },

  deleteTemplate(data: TemplateReqData) {
    const url = `chart-templates/delete`;
    return api.post(url, data);
  },

  setProjectTemplate(data: TemplateReqData) {
    const url = `chart-templates/project/set`;
    return api.post(url, data);
  }
};

export default chartApi;
